import { Loader } from "@/components/Loader/Loader.tsx";
import { useTranslation } from "react-i18next";

export const ReservationOfferLoader = () => {
  const { t } = useTranslation();

  return (
    <div className="c-reservation-offer-loader">
      <Loader loading />
      <span className="c-reservation-offer-loader__text">{t("loadingReservationOffer")}</span>
    </div>
  );
};
